export default {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};
